module.exports = __webpack_public_path__ + "img/development.3268be40.svg";